/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:767px){.s-margin[_ngcontent-%COMP%]{margin-bottom:25px}}"];
export { styles as styles };
